/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type ExcludedSlots = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MeetingReliefSettingVisibility = "DisabledByPaywall" | "HideSetting" | "ShowWithBadge" | "ShowWithoutBadge" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type NoMeetingDayOfWeek = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type WorkingHoursTypeEnum = "Base" | "Meeting" | "PreferredFocusTime" | "%future added value";
export type WebSettingsHoursAndPreferencesRelayQueryVariables = {
    orgRelayId: string;
};
export type WebSettingsHoursAndPreferencesRelayQueryResponse = {
    readonly viewer: {
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"RoomPreferencesSettings_viewer">;
    };
    readonly org: {
        readonly primaryOrgCalendar?: string | undefined;
        readonly experiments?: ReadonlyArray<string | null> | null | undefined;
        readonly primaryTeam?: ({
            readonly __typename: "Team";
            readonly teamId: string;
            readonly settings: {
                readonly __typename: "TeamSettings";
                readonly useNoMeetingDay: boolean;
                readonly noMeetingDayOfWeek: NoMeetingDayOfWeek;
            } | {
                readonly __typename: "GraphEntityError";
                readonly statusCode: number | null;
                readonly message: string | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
            readonly userSettings: {
                readonly __typename: "TeamUserSettings";
                readonly useNoMeetingDay: boolean;
            } | {
                readonly __typename: "GraphEntityError";
                readonly statusCode: number | null;
                readonly message: string | null;
            } | {
                /*This will never be '%other', but we need some
                value in case none of the concrete values match.*/
                readonly __typename: "%other";
            };
        } | {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        }) | null | undefined;
        readonly userMeetingHours?: {
            readonly id: string;
            readonly hasBeenSet: boolean | null;
            readonly workingHours: {
                readonly id: string;
                readonly type: WorkingHoursTypeEnum | null;
                readonly timeZone: string | null;
                readonly daySettings: ReadonlyArray<{
                    readonly day: Day | null;
                    readonly setting: {
                        readonly minSlot: MinSlot | null;
                        readonly maxSlot: MaxSlot | null;
                        readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                    } | null;
                } | null> | null;
                readonly dayOverrides: ReadonlyArray<{
                    readonly date: string | null;
                    readonly setting: {
                        readonly minSlot: MinSlot | null;
                        readonly maxSlot: MaxSlot | null;
                        readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null | undefined;
        readonly userWorkingHours?: {
            readonly id: string;
            readonly hasBeenSet: boolean | null;
            readonly workingHours: {
                readonly id: string;
                readonly type: WorkingHoursTypeEnum | null;
                readonly timeZone: string | null;
                readonly daySettings: ReadonlyArray<{
                    readonly day: Day | null;
                    readonly setting: {
                        readonly minSlot: MinSlot | null;
                        readonly maxSlot: MaxSlot | null;
                        readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                    } | null;
                } | null> | null;
                readonly dayOverrides: ReadonlyArray<{
                    readonly date: string | null;
                    readonly setting: {
                        readonly minSlot: MinSlot | null;
                        readonly maxSlot: MaxSlot | null;
                        readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null | undefined;
        readonly featureGrid?: {
            readonly __typename: "FeatureGrid";
            readonly featureStates: {
                readonly meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
            };
        } | {
            readonly __typename: "GraphEntityError";
            readonly statusCode: number | null;
            readonly message: string | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
        readonly " $fragmentRefs": FragmentRefs<"WebSettingsWorkingHours_org" | "GoalsWrapper_org" | "WorkPreferenceStartEndGoal_org" | "RoomPreferencesSettings_org">;
    } | null;
};
export type WebSettingsHoursAndPreferencesRelayQuery = {
    readonly response: WebSettingsHoursAndPreferencesRelayQueryResponse;
    readonly variables: WebSettingsHoursAndPreferencesRelayQueryVariables;
};



/*
query WebSettingsHoursAndPreferencesRelayQuery(
  $orgRelayId: ID!
) {
  viewer {
    id
    ...RoomPreferencesSettings_viewer
  }
  org: node(id: $orgRelayId) {
    __typename
    ... on Org {
      ...WebSettingsWorkingHours_org
      ...GoalsWrapper_org
      ...WorkPreferenceStartEndGoal_org
      ...RoomPreferencesSettings_org
      primaryOrgCalendar
      experiments
      primaryTeam {
        __typename
        ... on Team {
          teamId
          settings {
            __typename
            ... on TeamSettings {
              useNoMeetingDay
              noMeetingDayOfWeek
            }
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
          userSettings {
            __typename
            ... on TeamUserSettings {
              useNoMeetingDay
            }
            ... on GraphEntityError {
              statusCode
              message
            }
            ... on Node {
              __isNode: __typename
              id
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
      userMeetingHours(resolveOverrides: false) {
        id
        hasBeenSet
        workingHours {
          id
          type
          timeZone
          daySettings {
            day
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
          dayOverrides {
            date
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
        }
      }
      userWorkingHours(resolveOverrides: false) {
        id
        hasBeenSet
        workingHours {
          id
          type
          timeZone
          daySettings {
            day
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
          dayOverrides {
            date
            setting {
              minSlot
              maxSlot
              excludedSlots
            }
          }
        }
      }
      featureGrid {
        __typename
        ... on FeatureGrid {
          featureStates {
            meetingReliefSettingVisibility
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
    id
  }
}

fragment GoalsWrapper_org on Org {
  ...MeetingReliefGoal_org
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        name
        isDeleted
      }
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      featureStates {
        meetingReliefSettingVisibility
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment MeetingReliefGoal_org on Org {
  id
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        name
        isDeleted
        targetUrn {
          id
        }
        otherUrns {
          id
        }
        valueUrn {
          id
        }
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalMeetingReliefOptions {
              fatigueThresholdMinutes
              meetingReliefBreakMinutes
            }
          }
        }
      }
    }
  }
  featureGrid {
    __typename
    ... on FeatureGrid {
      featureStates {
        meetingReliefSettingVisibility
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment RoomPreferencesSettings_org on Org {
  id
  suggestedRoomPreferences {
    __typename
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on SuggestedRoomPreferences {
      suggestedRooms {
        isPreferred
        isSuggested
        room {
          roomId
          name
          orgId
          estimatedCapacity
          reportedCapacity
          id
        }
      }
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
}

fragment RoomPreferencesSettings_viewer on Viewer {
  roomQueryResult(query: "", orgRelayId: "", excludeCalendars: []) {
    __typename
    ... on GraphEntityError {
      message
      statusCode
    }
    ... on ExternalRoomSearchResult {
      searchQuery
      cacheable
      rooms {
        roomId
        name
        orgId
        estimatedCapacity
        reportedCapacity
        id
      }
    }
  }
}

fragment WebSettingsWorkingHours_org on Org {
  primaryOrgCalendar
  experiments
  primaryTeam {
    __typename
    ... on Team {
      teamId
      settings {
        __typename
        ... on TeamSettings {
          useNoMeetingDay
          noMeetingDayOfWeek
        }
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
      userSettings {
        __typename
        ... on TeamUserSettings {
          useNoMeetingDay
        }
        ... on GraphEntityError {
          statusCode
          message
        }
        ... on Node {
          __isNode: __typename
          id
        }
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  userMeetingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
  userWorkingHours(resolveOverrides: false) {
    id
    hasBeenSet
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
  }
}

fragment WorkPreferenceStartEndGoal_org on Org {
  id
  userGoals(first: 1000000) {
    edges {
      node {
        id
        goalId
        name
        isDeleted
        options {
          syncToGoogle
          specificOptions {
            __typename
            ... on GoalPreferredWorkOptions {
              keepEndOfDayOpen
              keepStartOfDayOpen
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "orgRelayId"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryOrgCalendar",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "experiments",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "useNoMeetingDay",
        "storageKey": null
    } as any, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/),
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "noMeetingDayOfWeek",
                "storageKey": null
            }
        ],
        "type": "TeamSettings",
        "abstractKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v11 = {
        "kind": "InlineFragment",
        "selections": [
            (v9 /*: any*/),
            (v10 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v12 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/)
        ],
        "type": "TeamUserSettings",
        "abstractKey": null
    } as any, v13 = [
        {
            "kind": "Literal",
            "name": "resolveOverrides",
            "value": false
        } as any
    ], v14 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v15 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasBeenSet",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "WorkingHours",
            "kind": "LinkedField",
            "name": "workingHours",
            "plural": false,
            "selections": [
                (v1 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "timeZone",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DaySetting",
                    "kind": "LinkedField",
                    "name": "daySettings",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "day",
                            "storageKey": null
                        },
                        (v14 /*: any*/)
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "DayOverride",
                    "kind": "LinkedField",
                    "name": "dayOverrides",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "date",
                            "storageKey": null
                        },
                        (v14 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v16 = {
        "alias": null,
        "args": (v13 /*: any*/),
        "concreteType": "UserMeetingHours",
        "kind": "LinkedField",
        "name": "userMeetingHours",
        "plural": false,
        "selections": (v15 /*: any*/),
        "storageKey": "userMeetingHours(resolveOverrides:false)"
    } as any, v17 = {
        "alias": null,
        "args": (v13 /*: any*/),
        "concreteType": "UserWorkingHours",
        "kind": "LinkedField",
        "name": "userWorkingHours",
        "plural": false,
        "selections": (v15 /*: any*/),
        "storageKey": "userWorkingHours(resolveOverrides:false)"
    } as any, v18 = {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "featureGrid",
        "plural": false,
        "selections": [
            (v5 /*: any*/),
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FeatureStates",
                        "kind": "LinkedField",
                        "name": "featureStates",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "meetingReliefSettingVisibility",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "type": "FeatureGrid",
                "abstractKey": null
            },
            (v11 /*: any*/)
        ],
        "storageKey": null
    } as any, v19 = {
        "kind": "InlineFragment",
        "selections": [
            (v10 /*: any*/),
            (v9 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    } as any, v21 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roomId",
            "storageKey": null
        } as any,
        (v20 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orgId",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedCapacity",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reportedCapacity",
            "storageKey": null
        } as any,
        (v1 /*: any*/)
    ], v22 = [
        (v1 /*: any*/)
    ], v23 = {
        "kind": "InlineFragment",
        "selections": (v22 /*: any*/),
        "type": "Node",
        "abstractKey": "__isNode"
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "WebSettingsHoursAndPreferencesRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "RoomPreferencesSettings_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "primaryTeam",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "settings",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "userSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Team",
                                            "abstractKey": null
                                        },
                                        (v11 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "WebSettingsWorkingHours_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "GoalsWrapper_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "WorkPreferenceStartEndGoal_org"
                                },
                                {
                                    "args": null,
                                    "kind": "FragmentSpread",
                                    "name": "RoomPreferencesSettings_org"
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "WebSettingsHoursAndPreferencesRelayQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "excludeCalendars",
                                    "value": []
                                },
                                {
                                    "kind": "Literal",
                                    "name": "orgRelayId",
                                    "value": ""
                                },
                                {
                                    "kind": "Literal",
                                    "name": "query",
                                    "value": ""
                                }
                            ],
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "roomQueryResult",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/),
                                (v19 /*: any*/),
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "searchQuery",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "cacheable",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Room",
                                            "kind": "LinkedField",
                                            "name": "rooms",
                                            "plural": true,
                                            "selections": (v21 /*: any*/),
                                            "storageKey": null
                                        }
                                    ],
                                    "type": "ExternalRoomSearchResult",
                                    "abstractKey": null
                                }
                            ],
                            "storageKey": "roomQueryResult(excludeCalendars:[],orgRelayId:\"\",query:\"\")"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "org",
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        (v1 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "primaryTeam",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v6 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "settings",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v8 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v23 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "userSettings",
                                                    "plural": false,
                                                    "selections": [
                                                        (v5 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v23 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Team",
                                            "abstractKey": null
                                        },
                                        (v11 /*: any*/),
                                        (v23 /*: any*/)
                                    ],
                                    "storageKey": null
                                },
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "GoalConnection",
                                    "kind": "LinkedField",
                                    "name": "userGoals",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "GoalEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Goal",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v1 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "goalId",
                                                            "storageKey": null
                                                        },
                                                        (v20 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isDeleted",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "targetUrn",
                                                            "plural": false,
                                                            "selections": (v22 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "otherUrns",
                                                            "plural": true,
                                                            "selections": (v22 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Urn",
                                                            "kind": "LinkedField",
                                                            "name": "valueUrn",
                                                            "plural": false,
                                                            "selections": (v22 /*: any*/),
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "GoalOptions",
                                                            "kind": "LinkedField",
                                                            "name": "options",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "syncToGoogle",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "specificOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v5 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fatigueThresholdMinutes",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "meetingReliefBreakMinutes",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalMeetingReliefOptions",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "keepEndOfDayOpen",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "keepStartOfDayOpen",
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "GoalPreferredWorkOptions",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "userGoals(first:1000000)"
                                },
                                (v18 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "suggestedRoomPreferences",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v19 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SuggestedRoomPreference",
                                                    "kind": "LinkedField",
                                                    "name": "suggestedRooms",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isPreferred",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "isSuggested",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "Room",
                                                            "kind": "LinkedField",
                                                            "name": "room",
                                                            "plural": false,
                                                            "selections": (v21 /*: any*/),
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "SuggestedRoomPreferences",
                                            "abstractKey": null
                                        },
                                        (v23 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "1d656487dcfd9a0fae99a547c45677f3",
            "id": null,
            "metadata": {},
            "name": "WebSettingsHoursAndPreferencesRelayQuery",
            "operationKind": "query",
            "text": "query WebSettingsHoursAndPreferencesRelayQuery(\n  $orgRelayId: ID!\n) {\n  viewer {\n    id\n    ...RoomPreferencesSettings_viewer\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...WebSettingsWorkingHours_org\n      ...GoalsWrapper_org\n      ...WorkPreferenceStartEndGoal_org\n      ...RoomPreferencesSettings_org\n      primaryOrgCalendar\n      experiments\n      primaryTeam {\n        __typename\n        ... on Team {\n          teamId\n          settings {\n            __typename\n            ... on TeamSettings {\n              useNoMeetingDay\n              noMeetingDayOfWeek\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userSettings {\n            __typename\n            ... on TeamUserSettings {\n              useNoMeetingDay\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      userMeetingHours(resolveOverrides: false) {\n        id\n        hasBeenSet\n        workingHours {\n          id\n          type\n          timeZone\n          daySettings {\n            day\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n          dayOverrides {\n            date\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n        }\n      }\n      userWorkingHours(resolveOverrides: false) {\n        id\n        hasBeenSet\n        workingHours {\n          id\n          type\n          timeZone\n          daySettings {\n            day\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n          dayOverrides {\n            date\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n        }\n      }\n      featureGrid {\n        __typename\n        ... on FeatureGrid {\n          featureStates {\n            meetingReliefSettingVisibility\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment GoalsWrapper_org on Org {\n  ...MeetingReliefGoal_org\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n      }\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      featureStates {\n        meetingReliefSettingVisibility\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment MeetingReliefGoal_org on Org {\n  id\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n        targetUrn {\n          id\n        }\n        otherUrns {\n          id\n        }\n        valueUrn {\n          id\n        }\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalMeetingReliefOptions {\n              fatigueThresholdMinutes\n              meetingReliefBreakMinutes\n            }\n          }\n        }\n      }\n    }\n  }\n  featureGrid {\n    __typename\n    ... on FeatureGrid {\n      featureStates {\n        meetingReliefSettingVisibility\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment RoomPreferencesSettings_org on Org {\n  id\n  suggestedRoomPreferences {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on SuggestedRoomPreferences {\n      suggestedRooms {\n        isPreferred\n        isSuggested\n        room {\n          roomId\n          name\n          orgId\n          estimatedCapacity\n          reportedCapacity\n          id\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment RoomPreferencesSettings_viewer on Viewer {\n  roomQueryResult(query: \"\", orgRelayId: \"\", excludeCalendars: []) {\n    __typename\n    ... on GraphEntityError {\n      message\n      statusCode\n    }\n    ... on ExternalRoomSearchResult {\n      searchQuery\n      cacheable\n      rooms {\n        roomId\n        name\n        orgId\n        estimatedCapacity\n        reportedCapacity\n        id\n      }\n    }\n  }\n}\n\nfragment WebSettingsWorkingHours_org on Org {\n  primaryOrgCalendar\n  experiments\n  primaryTeam {\n    __typename\n    ... on Team {\n      teamId\n      settings {\n        __typename\n        ... on TeamSettings {\n          useNoMeetingDay\n          noMeetingDayOfWeek\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      userSettings {\n        __typename\n        ... on TeamUserSettings {\n          useNoMeetingDay\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  userMeetingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n  userWorkingHours(resolveOverrides: false) {\n    id\n    hasBeenSet\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n  }\n}\n\nfragment WorkPreferenceStartEndGoal_org on Org {\n  id\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalPreferredWorkOptions {\n              keepEndOfDayOpen\n              keepStartOfDayOpen\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '3d83f410cdc163c519df3b50034c7977';
export default node;
